(function() {
    'use strict';

    angular
        .module('etrrbApp')
        .controller('EtrrbCancelRequestDialogController', EtrrbCancelRequestDialogController);

    EtrrbCancelRequestDialogController.$inject = ['$scope', '$uibModalInstance', 'ETrrbService', 'etrrbInfo', 'Upload', '$log', 'authExpiredInterceptor','$window','ETRRB_REASON_CANCEL','isCancelFlag'];

    function EtrrbCancelRequestDialogController ($scope, $uibModalInstance, ETrrbService, etrrbInfo, Upload, $log, authExpiredInterceptor,$window, ETRRB_REASON_CANCEL, isCancelFlag) {
    	var etrrbCancelDialogCtr = this;
    	etrrbCancelDialogCtr.agentCode = etrrbInfo.eTrrbTransaction.agentCode;
    	etrrbCancelDialogCtr.agentName = etrrbInfo.eTrrbTransaction.agentName;
    	etrrbCancelDialogCtr.policyNum = etrrbInfo.eTrrbReceipts[0].policyNum;
    	etrrbCancelDialogCtr.proposalNum = etrrbInfo.eTrrbReceipts[0].proposalNum;
    	etrrbCancelDialogCtr.bookletNum = etrrbInfo.eTrrbTransaction.bookletNum;
    	etrrbCancelDialogCtr.attachment = null;
    	etrrbCancelDialogCtr.cancel= cancel;
    	etrrbCancelDialogCtr.ok = doRequestCancelBooklet;
    	etrrbCancelDialogCtr.cancel = cancel;
    	etrrbCancelDialogCtr.isCancelBooklet = etrrbInfo.eTrrbTransaction.isCancelBooklet;
    	etrrbCancelDialogCtr.returnBooklet = returnBooklet;
    	etrrbCancelDialogCtr.txnType = etrrbInfo.eTrrbTransaction.txnType;
    	etrrbCancelDialogCtr.txnId = etrrbInfo.eTrrbTransaction.txnId;
    	etrrbCancelDialogCtr.remove =remove;
    	// reason for cancel booklet
    	etrrbCancelDialogCtr.reasonCancel = etrrbInfo.eTrrbTransaction.reasonCancel;
    	etrrbCancelDialogCtr.ETRRB_REASON_CANCEL = ETRRB_REASON_CANCEL;
    	etrrbCancelDialogCtr.changeReasonCancel = changeReasonCancel;
    	etrrbCancelDialogCtr.isShowRemarks = false;
    	etrrbCancelDialogCtr.isDisableBtn = true;
    	etrrbCancelDialogCtr.changeRemarks = changeRemarks;
    	etrrbCancelDialogCtr.disableReasonCancel = isCancelFlag;
    	changeReasonCancel();
    	etrrbCancelDialogCtr.remarks = etrrbInfo.eTrrbTransaction.remarks;
	    function cancel() {
		   $uibModalInstance.dismiss(false);
	    };
	    if(etrrbInfo.eTrrbTransaction.archiveDataId != null && etrrbCancelDialogCtr.isCancelBooklet == '1'){
	    	ETrrbService.get({
				uri : 'find-by-archiveDataId',
				archiveDataId: etrrbInfo.eTrrbTransaction.archiveDataId
			}, function(result) {
				etrrbCancelDialogCtr.attachment = result;
			}, function(error) {
				
			});
	    };
	 // Save Request
		function doRequestCancelBooklet() {
			 $scope.clearMessage();
			var data = [];
			$scope.loading=true;
			if (etrrbCancelDialogCtr.attachment) {
				data['file'] = etrrbCancelDialogCtr.attachment;
				data['txnId'] = new Blob([ JSON
						.stringify(etrrbInfo.eTrrbTransaction.txnId) ], {
					type : "application/json"
				});
				var jsonReasonCancel = JSON.stringify(etrrbCancelDialogCtr.reasonCancel);
				data['reasonCancel'] = new Blob([ jsonReasonCancel ], {
					type : "application/json"
				});
				
				var jsonRemarks = JSON.stringify(etrrbCancelDialogCtr.remarks);
				data['remarks'] = new Blob([ jsonRemarks ], {
					type : "application/json"
				});
				
			}
			Upload.upload(
			{
				url : GLOBAL_URL
						+ 'api/ga/etrrb/do-request-cancel-booklet?access_token='
						+ authExpiredInterceptor.getToken(),
				data : data
			}).then(
			function(resp) {
				$scope.loading=false;
				$log.debug('Success ' + resp.config.data.file.name
						+ 'uploaded. Response: ' + resp.data);
				$scope.addAlert('Gửi yêu cầu hủy thành công.','success');
				$uibModalInstance.close(true);
			},
			function(error) {
				$scope.loading=false;
				$scope.addAlert('Gửi yêu cầu hủy thất bại. Trạng thái PT ['+etrrbInfo.eTrrbTransaction.bookletNum+'] không đúng. Vui lòng kiểm tra lại.','error');
				$uibModalInstance.close(true);
			},
			function(evt) {
				var progressPercentage = parseInt(100.0
						* evt.loaded / evt.total);
				$log.debug('progress: ' + progressPercentage + '% '
						+ evt.config.data.file.name);
			});
				
		}
		
		function cancel() {
			 $scope.loading=true;
	    	ETrrbService.get({
				uri : 'cancel-receipt-ettrb',
				bookletNum: etrrbCancelDialogCtr.bookletNum,
				txnType: etrrbCancelDialogCtr.txnType
			}, function(result) {
				$scope.addAlert('Hủy thành công.' + result.cancelDate,'info');
				$scope.loading = false;
				$uibModalInstance.close(true);
			}, function(error) {
				$scope.addAlert('Hủy không thành công. Vui lòng kiểm tra lại','danger');
				$scope.loading = false;
				$uibModalInstance.close(true);
			});
	    	
	    };
	    function returnBooklet() {
	    	 $scope.loading = true;
	    	ETrrbService.get({
				uri : 'return-receipt-ettrb',
				txnId:etrrbInfo.eTrrbTransaction.txnId
			}, function(result) {
				$scope.addAlert('Trả lại giao dịch thành công.','info');
				$scope.loading = false;
				$uibModalInstance.close(true);
			}, function(error) {
				$scope.addAlert('Trả lại giao dịch không thành công. Vui lòng kiểm tra lại','danger');
				$scope.loading = false;
				$uibModalInstance.close(true);
			});
	    	
	    };
	    
	    function changeReasonCancel() {
			etrrbCancelDialogCtr.remarks = '';
			if (etrrbCancelDialogCtr.reasonCancel == '') {
				etrrbCancelDialogCtr.isDisableBtn = true;
			} else if (etrrbCancelDialogCtr.reasonCancel == '04') {
				etrrbCancelDialogCtr.isShowRemarks = true;
				changeRemarks();
			} else {
				etrrbCancelDialogCtr.isDisableBtn = false;
				etrrbCancelDialogCtr.isShowRemarks = false;
			}
		}

		function changeRemarks() {
			if (etrrbCancelDialogCtr.remarks != '') {
				etrrbCancelDialogCtr.isDisableBtn = false;
			} else {
				etrrbCancelDialogCtr.isDisableBtn = true;
			}
		}
	    
	    etrrbCancelDialogCtr.downLoadAttachment = function(attachmentId,txnId) {
	    	ETrrbService.get({
			uri : 'get-file-attach',
				archiveDataId : attachmentId,
				txnId:  txnId
			}, function(result) {
				 var byteCharacters = atob(result.dataContent);
				  var byteNumbers = new Array(byteCharacters.length);
				  for (var i = 0; i < byteCharacters.length; i++) {
					    byteNumbers[i] = byteCharacters.charCodeAt(i);
				  }
				  var byteArray = new Uint8Array(byteNumbers);
				  var blob=new Blob([byteArray], {type: result.type});
				  if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
						window.navigator.msSaveBlob(blob, result.dataName);
			       } else { // for other browsers  
					    var url = $window.URL || $window.webkitURL;
					    var aTag = document.createElement("a");
			    		aTag.style = "display: none";
			    		aTag.target = "_blank";
			    		aTag.href = url.createObjectURL(blob);
			    		aTag.download = result.dataName;
			    		aTag.click();
			       }
			}, function(error) {
				$scope.addAlert('Không tìm thấy file. Vui lòng thử lại','warning');
			});
		};
		function remove() {
			   $uibModalInstance.dismiss(false);
		    };
    }
})();
